var React = require('react');

function Maximize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 4H12C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12V24M76 24V12C76 9.87827 75.1571 7.84344 73.6569 6.34315C72.1566 4.84285 70.1217 4 68 4H56M4 56V68C4 70.1217 4.84285 72.1566 6.34315 73.6569C7.84344 75.1571 9.87827 76 12 76H24M56 76H68C70.1217 76 72.1566 75.1571 73.6569 73.6569C75.1571 72.1566 76 70.1217 76 68V56","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Maximize.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Maximize;

Maximize.default = Maximize;
